export function NotFoundPage({ onNavigate }: { onNavigate: (path: string) => void }) {
  return (
    <div className="page-header">
      <div>
        <h1>Route not found</h1>
        <p>This path is not part of the preview console.</p>
        <div style={{ marginTop: 16 }}>
          <button type="button" className="btn btn-primary" onClick={() => onNavigate("/dashboard/overview")}>
            Back to overview
          </button>
        </div>
      </div>
    </div>
  );
}
